import store from "@/store";
import {clone} from "@/utils/cloneUtil";
import {Slide} from "@/store/slides2Video/slides2VideoModels";
import {UPDATE_SLIDES} from "@/store/slides2Video/slides2VideoAction";


export const updateCurrentSlide = (newSlide:Slide) => {
    const currentSlideIndex=store.getters.getCurrentSlideIndex;
    const slidesClone=clone(store.getters.slides) as Slide[];
    for(const slide of slidesClone){
        if(currentSlideIndex+1===slide.order){
            slide.text=newSlide.text;
            slide.script=newSlide.script;
            slide.layout=newSlide.layout;
            slide.originalDocumentB64=newSlide.originalDocumentB64;
            slide.avatarBackground=newSlide.avatarBackground;
            slide.avatar=newSlide.avatar;
            slide.lang=newSlide.lang;
            slide.accent=newSlide.accent;
            slide.voice=newSlide.voice;
            slide.slideDescription=newSlide.slideDescription;
            slide.slideTitle=newSlide.slideTitle;
            slide.slideTemplate=newSlide.slideTemplate;
            slide.slideTheme=newSlide.slideTheme;
            slide.slideBackgroundColor=newSlide.slideBackgroundColor;
            slide.promptIllustrationGeneration=newSlide.promptIllustrationGeneration;
            slide.slideImageB64=newSlide.slideImageB64;
            slide.chunkVideoUrl=newSlide.chunkVideoUrl;
            slide.videoTimestampStart=newSlide.videoTimestampStart;
            slide.videoTimestampEnd=newSlide.videoTimestampEnd;
            slide.documentType=newSlide.documentType;
            slide.slideVideoUrl=newSlide.slideVideoUrl;
            break;
        }
    }
    store.dispatch(UPDATE_SLIDES,slidesClone)
}

/**
 * The slide editor keeps the text being typed in its contenteditable and only pushes it
 * to the store on focusout. Anything asking "is there work to lose?" must therefore force
 * that flush first, else it reads a slide that still looks empty.
 * AISlidePanel registers its flush here while it is mounted.
 */
let slideEditingFlush: (() => void) | null = null;

export const registerSlideEditingFlush = (flush: (() => void) | null) => {
    slideEditingFlush = flush;
};

export const flushSlideEditing = () => {
    if (slideEditingFlush) {
        slideEditingFlush();
    }
};

/**
 * True when the slides in the store hold work the user would not want to lose:
 * an edited/generated deck, an imported document, a generated illustration...
 * The lonely untouched slide created by RESET_SLIDES_2_VIDEO is not work in progress.
 */
export const hasSlideWorkInProgress = (): boolean => {
    // the text being typed right now is part of the work to protect
    flushSlideEditing();
    const slides = store.getters.slides as Slide[];
    if (!slides || slides.length === 0) {
        return false;
    }
    if (slides.length > 1) {
        return true;
    }
    const slide = slides[0];
    return !!(slide.slideTitle
        || slide.slideDescription
        || slide.script
        || slide.text
        || slide.documentName
        || slide.originalDocumentB64
        || slide.slideImageB64
        || slide.slideVideoUrl
        || slide.promptIllustrationGeneration);
};
